export default {"src":"/_next/static/media/plantura-logo-full.ec57143e.svg","height":84,"width":245};